var journalize = require('journalize');

import { capfirst, intcomma, intword } from 'journalize';

export function roundThousands(num) {
  var integer = 1000;
  if (num < 1000000) return intcomma(Math.round(num / integer) * integer);
  else return intword(num);
}

export const chunk = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

// Some seats have both a regular race and a special election for the unexpired
// term on the same ballot (same office_slug, same candidates). Keep only the
// regular race so each seat shows a single card.
export const dropDuplicateSpecials = entries =>
  entries.filter(
    entry =>
      entry.election_type !== 'special' ||
      !entries.some(
        other =>
          other.office_slug === entry.office_slug &&
          other.election_type === 'general'
      )
  );

export const delay = (function() {
  var timer = 0;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

export function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}

export function sort_candidates_alphabetically(candidates) {
  return candidates.sort((a, b) =>
    (a.sort_name || a.name || '').localeCompare(b.sort_name || b.name || '')
  );
}

// Display overrides for office names as they come from the data.
const OFFICE_DISPLAY_NAMES = {
  'Texas Fifteenth Court of Appeals': 'Texas 15th Court of Appeals',
};

export function formatOfficeName(office) {
  return OFFICE_DISPLAY_NAMES[office] || office;
}

export function determineDistrictTitle(contest) {
  return `${formatOfficeName(contest.office)} ${
    contest.office === 'President' ||
    contest.division_type === 'class' ||
    contest.division_type === 'statewide'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

export function determineContestTitle(contest) {
  if (contest.division_type === 'statewide' || contest.division_type === 'seat')
    return '';

  return determineDistrictTitle(contest);
}

export function determineContestTitleYourRaces(contest) {
  return determineDistrictTitle(contest);
}
